import React, { useState } from "react";
import "./archives.css";

import conference1 from "../../assets/images/conferences/1.jpg";
import conference2 from "../../assets/images/conferences/2.jpg";
import conference3 from "../../assets/images/conferences/3.jpg";
import conference4 from "../../assets/images/conferences/4.jpg";
import conference5 from "../../assets/images/conferences/5.jpg";
import conference6 from "../../assets/images/conferences/6.jpg";
import conference7 from "../../assets/images/conferences/7.jpg";
import conference8 from "../../assets/images/conferences/8.jpg";

const archives = [
  { image: conference1 },
  { image: conference2 },
  { image: conference3 },
  { image: conference4 },
  { image: conference5 },
  { image: conference6 },
  { image: conference7 },
  { image: conference8 },
];

const Archives = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoom, setZoom] = useState(1);

  const openModal = (image) => {
    setSelectedImage(image);
    setZoom(1);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const zoomIn = () => {
    setZoom((prevZoom) => prevZoom + 0.2);
  };

  const zoomOut = () => {
    setZoom((prevZoom) => (prevZoom > 1 ? prevZoom - 0.2 : 1));
  };

  return (
    <div className="archives-container">
      <h2>Previous Conferences</h2>
      <div className="grid-container">
        {archives.map((item, index) => (
          <div
            key={index}
            className="grid-item"
            onClick={() => openModal(item.image)}
          >
            <img
              src={item.image}
              alt={`Conference ${index + 1}`}
              className="grid-image"
            />
            <div className="overlay">
              <span>Click to enlarge</span>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="modal-close" onClick={closeModal}>
              X
            </button>
            <div className="modal-image-container">
              <img
                src={selectedImage}
                alt="Enlarged"
                style={{ transform: `scale(${zoom})` }}
              />
            </div>
            <div className="zoom-controls">
              <button onClick={zoomOut}>Zoom Out</button>
              <button onClick={zoomIn}>Zoom In</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Archives;
